import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { Config } from '@/config';
import { Async } from '@/utils/AsyncDecorators';
import { mediaStore } from '../store/media.store';
import { mediaConfiguration } from '../module';


@Component({})
export default class SlideShow extends Vue {
  @Prop()
  typeId: any;

  @Prop()
  type: string;

  @Prop()
  disabled:boolean;
  
  @Async({
    async get() {
      if (this.typeId && this.type) {
        return await mediaStore.getters.get(this.typeId, this.type);
      }
      return [];
    }, default: []
  })
  media: server.mediaDetail[];

  mediaToUpload: server.mediaUpload[] = [];
  mediaToDelete: server.mediaDetail[] = [];


  src(filename: string, container: string = "images"): string {
    return filename ? Config.cdn.apiServerUrl + `/image/resize/${filename}?width=${mediaConfiguration.defaultWidth}&height=${mediaConfiguration.defaultHeight}&crop=true&container=${container}` : "";
  }

  srcLocal(item) {
    return "data:image/jpeg;base64," + item + "";
  }

  deleteMedia(index: any, m: server.mediaDetail) {
    this.media.splice(index, 1);
    this.mediaToDelete.push(m);
  }

  deleteLocalMedia(index) {
    this.mediaToUpload.splice(index, 1)
  }

  async save(typeId: any) {
    for (const m of this.mediaToUpload) {
      m.typeId = typeId, await mediaStore.actions.set(m);
    }
    for (const m of this.mediaToDelete) {
      await mediaStore.actions.remove(m);
    }
  }

  newimage(image: server.mediaUpload) {
    this.mediaToUpload.push(image);
  }
}